import * as React from "react";
import {useState} from "react";
import Popup from "./Popup.tsx";
import {SmallSpinner} from "./SmallSpinner.tsx";

interface Props {
    title: string,
    onClick: () => void,
    className?: string,
    icon?: any,
    disabled?: boolean;
    loading?: boolean;
    disabledFeedback?: string;
    autoFocus?: boolean;
    variant?: 'default' | 'success' | 'danger';
    confirmation?: {
        title: string,
        description: string,
        acceptVerb: string
    }
}


export function PrimaryButton(props: Props) {
    const [visible, setVisible] = useState(false);

    const [isConfirmationPopupOpen, setIsConfirmationPopupOpen] = useState<boolean>(false);

    function handleOnClick() {
        if (props?.confirmation == null)
            props.onClick()
        else
            setIsConfirmationPopupOpen(true)
    }

    const variantColors = {
        default: "bg-primary hover:bg-darkprimary",
        success: "bg-green-600 hover:bg-green-500",
        danger: "bg-red-600 hover:bg-red-500",
    }[props.variant ?? 'default']

    let style = `relative flex items-center leading-0 rounded-md ${variantColors} px-3.5 py-1.5 shadow-sm text-[#f4f9fc] transition hover:transition focus:outline-none  focus:ring-offset-2 `

    const isInactive = props.disabled || props.loading

    if (isInactive) {
        style = "relative flex items-center leading-0 rounded-md bg-gray-200 px-3.5 py-1.5 text-gray-600 transition hover:transition cursor-not-allowed focus:outline-none  focus:ring-offset-2 "
    }

    return (
        <>
            <Popup
                open={isConfirmationPopupOpen}
                onClose={() => setIsConfirmationPopupOpen(false)}
                onConfirm={() => {
                    setIsConfirmationPopupOpen(false)
                    props.onClick()
                }}
                title={props?.confirmation?.title}
                confirmButtonDisplayLabel={props?.confirmation?.acceptVerb}
            >
                <div className="mt-2">
                    <p className="text-sm text-gray-700">
                        {props?.confirmation?.description}
                    </p>
                </div>
            </Popup>
            <button
                type="button"
                {...(props.autoFocus ? {'data-autofocus': true} : {})}
                onClick={(e) => {
                    if (isInactive)
                        return

                    handleOnClick()
                }}
                className={style + props.className}
                onMouseEnter={() => setVisible(true)}
                onMouseLeave={() => setVisible(false)}
                onFocus={() => setVisible(true)}
                onBlur={() => setVisible(false)}
                style={{outline: 'none'}}
                disabled={props.loading}
                aria-busy={props.loading}
            >
                {props.loading
                    ? <span className="mr-1.5"><SmallSpinner/></span>
                    : props.icon && <props.icon
                        className='h-5 w-5 mb-0.5 mr-1.5'
                    />}
                {
                    visible && props.disabled && !props.loading && props?.disabledFeedback && (
                        <span
                            className="block absolute z-50 left-0 bottom-full mb-2 w-max max-w-xs px-2 py-1 rounded bg-gray-200 text-xs shadow-lg whitespace-normal text-left"
                            role="tooltip"
                        >
                            {props?.disabledFeedback}
                        </span>
                    )
                }
                <span>{props.title}</span>
            </button>


        </>

    )
}
